import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { MessengerNetwork } from '@lite-workspace/dto-user';
import type { AuthType, OnboardingProgress, ProfilePatch, UserProfile } from './identity.models';
import type { IdentityData } from './identity.data';
import { IdentityApiService } from './identity-api.service';

@Injectable()
export class HttpIdentityData implements IdentityData {
  private readonly api = inject(IdentityApiService);

  getProfile(): Observable<UserProfile> {
    return this.api.getProfile();
  }

  updateProfile(patch: ProfilePatch): Observable<UserProfile> {
    return this.api.updateProfile(patch);
  }

  setPassword(body: { password?: string; authType?: AuthType }): Observable<void> {
    return this.api.setPassword(body);
  }

  connectMessenger(network: MessengerNetwork): Observable<string> {
    return this.api.connectMessenger(network);
  }

  disconnectMessenger(network: MessengerNetwork): Observable<void> {
    return this.api.disconnectMessenger(network);
  }

  dismissOnboardingFlow(flowId: string): Observable<OnboardingProgress> {
    return this.api.dismissOnboardingFlow(flowId);
  }

  completeOnboardingFlow(flowId: string): Observable<OnboardingProgress> {
    return this.api.completeOnboardingFlow(flowId);
  }

  markLessonViewed(flowId: string): Observable<OnboardingProgress> {
    return this.api.markLessonViewed(flowId);
  }

  unmarkLessonViewed(flowId: string): Observable<OnboardingProgress> {
    return this.api.unmarkLessonViewed(flowId);
  }

  markLessonFavorite(flowId: string): Observable<OnboardingProgress> {
    return this.api.markLessonFavorite(flowId);
  }

  unmarkLessonFavorite(flowId: string): Observable<OnboardingProgress> {
    return this.api.unmarkLessonFavorite(flowId);
  }
}
